<div class="rule-dialog">
  <div class="dialog-header">
    <span>Terms & Conditions</span>
    <cs-icon-button
      class="btn-close"
      iconType="icon"
      icon="fi-x"
      color="secondary"
      size="12"
      (buttonClick)="close()"
    ></cs-icon-button>
  </div>
  <div class="dialog-content">
    @if (currencyAmountList.length > 0) {
      <div class="title">Currency Equivalence</div>
      <div class="note">You can deposit in any of the following currencies.</div>
      <div class="list">
        @for (item of currencyAmountList; track item) {
          <div class="item">
            <div class="currency">{{ item.currency }}</div>
            <div class="amount">
              @if (!isFCFS(item.grantType)) {
                <span>
                  {{
                    this.isMultiplePrize
                      ? (item.minAmount | currencyValue: item.currency) +
                        ' - ' +
                        (item.maxAmount | currencyValue: item.currency)
                      : (item.minAmount | currencyValue: item.currency)
                  }}
                </span>
              }
              <img class="currency-icon" [src]="item.currency | currencyIcon" />
            </div>
          </div>
        }
      </div>
    }
    <div class="title">{{ activityName }}</div>
    @if (activityRules) {
      <div class="inner-html" [innerHTML]="activityRules | toHtmlElement"></div>
    } @else {
      <app-empty
        [title]="'Bonus Details Not Ready'"
        [message]="'The terms and conditions for this bonus aren\'t ready yet. Hang tight, they\'ll be revealed soon!'"
      ></app-empty>
    }
  </div>
  <div class="dialog-btn">
    <cs-button class="close-btn" [height]="'48px'" [size]="'large'" [label]="'Close'" (buttonClick)="close()" />
  </div>
</div>
